import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  id: "search",
  width: "80",
  height: "80",
  viewBox: "0 0 21 21"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("defs", null, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  id: "Path_2509",
  d: "M9.75 16.5a6.75 6.75 0 1 1 6.75-6.75 6.758 6.758 0 0 1-6.75 6.75zm0-15A8.25 8.25 0 1 0 18 9.75 8.25 8.25 0 0 0 9.75 1.5z",
  class: "cls-1",
  transform: "translate(-1.5 -1.5)"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  id: "Path_2510",
  d: "M17.146 16.086a9.85 9.85 0 0 1-1.06 1.06L21.44 22.5l1.06-1.061z",
  class: "cls-1",
  transform: "translate(-1.5 -1.5)"
}, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_5]))
}
export default { render };